import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldIcon, TargetIcon, MoonIcon } from 'lucide-react';
const steps = [{
  icon: ShieldIcon,
  title: 'Reconfigurás el ambiente',
  description: 'Eliminás los disparadores de energía nocturna en tu casa.'
}, {
  icon: TargetIcon,
  title: 'Aplicás el Ciclo de Caza',
  description: 'Ejecutás el método 15-5-10 antes de tu cena.'
}, {
  icon: MoonIcon,
  title: 'Extinguís la conducta',
  description: 'Seguís el protocolo de las 3 AM para que el gato entienda que el maullido ya no funciona.'
}];
export function HowItWorks() {
  return <section className="py-10 sm:py-14 relative" data-id="element-136">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-137">
        <FadeIn data-id="element-138">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10" data-id="element-139">
            Cómo funciona en 3 pasos
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-140">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-gold/0 via-gold/20 to-gold/0 z-0" data-id="element-141" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-142">
              <div className="flex flex-col items-center text-center" data-id="element-143">
                <div className="w-24 h-24 rounded-full bg-navy border-2 border-gold/30 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(212,168,83,0.1)] relative" data-id="element-144">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold text-navy-dark font-bold flex items-center justify-center font-sans" data-id="element-145">
                    {index + 1}
                  </div>
                  <step.icon className="h-10 w-10 text-gold" data-id="element-146" />
                </div>
                <h3 className="text-xl font-bold text-slate-100 mb-3" data-id="element-147">
                  {step.title}
                </h3>
                <p className="text-slate-400 font-sans" data-id="element-148">{step.description}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}